import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=38a79e0e&scoped=true&"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts&"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts&"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=38a79e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a79e0e",
  null
  
)

export default component.exports